<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="all"
      :search="search"
      single-select
      show-select
      :footer-props="{
        itemsPerPageText: 'Filas por página'
      }"
      :loading="loading"
      :options.sync="optionsLocal"
      :server-items-length="itemsLength"
      disable-sort
    >
      <template v-slot:top>
        <v-toolbar flat dark extended :color="colorToolbar">
          <v-text-field
            v-model="searchText"
            label="Escriba"
            flat
            solo-inverted
            hide-details
            clearable
            @keydown.enter="onFetch"
            @click:clear="onClear"
          >
            <template v-slot:prepend>
              <v-btn
                icon
                color="primary"
                @click="onFetch"
                :disabled="!searchText || searchText.length == 0"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-text-field>

          <template v-slot:extension>
            <v-scroll-x-reverse-transition>
              <v-btn
                v-if="selected.length && $can('choferes.update')"
                :disabled="selected.length > 1"
                text
                color="warning"
                @click="onEdit(selected)"
              >
                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-pencil</v-icon>
                <div class="hidden-xs-only">Editar</div>
              </v-btn>
            </v-scroll-x-reverse-transition>
            <v-scroll-x-reverse-transition>
              <v-btn
                v-if="selected.length && $can('choferes.destroy')"
                text
                color="error"
                @click="onDelete(selected)"
              >
                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-delete</v-icon>
                <div class="hidden-xs-only">Borrar</div>
              </v-btn>
            </v-scroll-x-reverse-transition>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="onCreate"
              v-if="$can('choferes.store')"
            >
              <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-plus</v-icon>
              <div class="hidden-xs-only">Agregar</div>
            </v-btn>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.activo="{ item }">
        {{ item.activo ? 'Si' : 'No' }}
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="mdi-alert">
          No se ha encontrado ningún resultado para "{{ search }}".
        </v-alert>
      </template>
      <template v-slot:no-data>
        <v-alert :value="true" color="warning" icon="mdi-alert">
          No hay información de choferes para mostrar.
        </v-alert>
      </template>
      <template v-slot:pageText="props">
        Filas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      title: 'Listado de choferes',
      search: '',
      selected: [],
    }
  },
  created () {
    // this.onFetch()
  },
  computed: {
    ...mapGetters('Choferes', ['all', 'headers', 'loading', 'itemsLength', 'options', 'filters']),
    optionsLocal: {
      get () {
        return this.options
      },
      set (value) {
        this.setOptions(value)
        this.onFetch()
      }
    },
    searchText: {
      get () {
        return this.filters.searchText
      },
      set (value) {
        this.setFilterSearchText(value)
      }
    },
    colorToolbar () {
      return this.selected.length ? 'listSelected' : 'toolbarList'
    },
  },
  methods: {
    ...mapActions({
      onFetch: 'Choferes/onFetch',
    }),
    ...mapMutations({
      setFilterSearchText: 'Choferes/setFilterSearchText',
      setOptions: 'Choferes/setOptions',
      setSelected: 'Choferes/setSelected',
    }),
    onCreate () {
      this.$router.push({ name: 'choferes-create' })
    },
    onEdit (selected) {
      this.$router.push({ name: 'choferes-edit', params: { id: selected[0].id }})
    },
    onDelete (selected) {
      this.$router.push({ name: 'choferes-delete', params: { id: selected[0].id }})
    },
    onClear () {
      this.setFilterSearchText()
      this.onFetch()
    }
  }
}
</script>
